import React, { forwardRef, memo } from 'react';
import cx from 'classnames';
import styles from './Card.module.scss';
const Card = forwardRef(({ children, variant = 'minimal', className, size, ...rest }, ref) => {
    const cardClasses = cx(styles.dscard, styles[`variant-${variant}`], size && styles[`size-${size}`], className);
    return (React.createElement("div", { ref: ref, className: cardClasses, ...rest }, children));
});
Card.displayName = 'Card';
export default memo(Card);
